export const USERHISTORY_REQUEST = "USERHISTORY_REQUEST";
export const USERHISTORY_SUCCESS = "USERHISTORY_SUCCESS";
export const USERHISTORY_FAILURE = "USERHISTORY_FAILURE";

export const USERHISTORY_BYID_REQUEST = "USERHISTORY_BYID_REQUEST";
export const USERHISTORY_BYID_SUCCESS = "USERHISTORY_BYID_SUCCESS";
export const USERHISTORY_BYID_FAILURE = "USERHISTORY_BYID_FAILURE";